import { customSizes } from '@kimuno/theme';
import { Box } from '@mui/material';

import { UserPaymentMethodType } from '../../types/User';

interface PaymentZouraContentProps {
	method: UserPaymentMethodType;
	hasCreditCardErrors?: boolean;
}

const PaymentZouraContent = ({ method, hasCreditCardErrors }: PaymentZouraContentProps) => {
	const isCreditCard = method === UserPaymentMethodType.CREDIT_CARD;
	const height = isCreditCard
		? {
				xs: customSizes.paymentMethods.creditCardForm.height.mobile,
				lg: customSizes.paymentMethods.creditCardForm.height.desktop,
			}
		: customSizes.paymentMethods.sepaForm.height;

	return (
		<Box
			id="zuora_payment"
			data-testid={`${method.toLowerCase()}-payment-page`}
			sx={{
				minHeight: height,
				'& iframe': {
					width: '100%',
					minHeight: 'inherit',
					...(isCreditCard && !hasCreditCardErrors ? { height: 'auto' } : {}),
				},
			}}
		/>
	);
};

export default PaymentZouraContent;
